<template>
    <div>
        <b-table
            hover
            sticky-header="100%"
            show-empty
            :items="items"
            :fields="fields"
        >
            <template #cell(realizators)="data">
                <div v-for="item in data.item.realizators" :key="item.id">
                    <span>{{ item.name }}</span>
                </div>
            </template>
            <template #cell(creator)="data">
                <span>{{ data.value.name }}</span>
            </template>
            <template #cell(realization_at)="data">
                <span>{{ data.value | formattedDateTime }}</span>
            </template>
            <template #cell(created_at)="data">
                <span>{{ data.value | formattedDateTime }}</span>
            </template>
            <template #cell(reference_status_id)="data">
                <span v-html="handlerTaskStatus(data.value)"></span>
            </template>
            <template #cell(action)="data">
                <button
                    class="btn btn-secondary"
                    @click="openTaskSidebar(data.item)"
                >открыть</button>
            </template>
            <template #empty="scope">
                <p class="my-4"><em>Задачи по заданному фильтру отсутствуют... Создайте новую задачу прямо сейчас!</em></p>
            </template>
        </b-table>
    </div>
</template>


<script>
import { API_TASKS } from '@/constants';
import { mixinTasks } from '@/mixins';
import { openTaskSidebar } from '@/mixins/openTaskSidebar';
import { mapGetters } from 'vuex';

export default {
    props: {
        changeLoadTaskList: { type: Boolean, required: true },
        modelName: { type: String, required: true },
        modelId: { type: Number, required: true }
    },

    mixins: [
        mixinTasks,
        openTaskSidebar
    ],

    data() {
        return {
            items: [],
            fields: [
                { key: 'id', label: 'ID' },
                { key: 'creator.name', label: 'Постановщик' },
                { key: 'title', label: 'Заголовок' },
                { key: 'realizators', label: 'Исполнители' },
                { key: 'realization_at', label: 'Выполнить' },
                { key: 'created_at', label: 'Дата создания' },
                { key: 'reference_status_id', label: 'Статус', class: 'text-center' },
                { key: 'action', label: 'Действие', class: 'text-center' },
            ],
        }
    },

    computed: {
        ...mapGetters('task', ['GET_TASK']),
    },

    watch: {
        changeLoadTaskList: function() {
            this.getAllHistoryTasks();
        },
        GET_TASK: {
            handler(task) {
                const index = this.items.findIndex(t => t.id === task.id);

                if (index !== -1) {
                    Object.assign(this.items[index], task);
                }
            },
            deep: true
            }
    },

    methods: {
        getAllHistoryTasks() {
            api.call('get', `${API_TASKS}?model_name=${this.modelName}&model_id=${this.modelId}`)
            .then(({data}) => {
                this.items = data.data;
            })
        },
        handlerTaskStatus(id) {
            if (id == 400) {return 'К выполнению'}
            if (id == 401) {return 'В работе'}
            if (id == 402) {return 'На проверке'}
            if (id == 403) {return 'Выполнено'}
        }
    },

    mounted() {
        this.getAllHistoryTasks();
    }
}
</script>
